<mat-card data-qa="aufgabe-card">
  <div class="background-{{aufgabe.type}}">
    <mat-card-actions>
      <div class="type type-{{aufgabe.type}}">{{ aufgabe.type | aufgabeTypeReadable }}</div>
      @if (aufgabe.mitUenbTeilen && authenticationService.isUenb(uflaUser); ) {
        <div class="mit-uenb-teilen"
             data-qa="erstellt-von-ersteller">
          Erstellt von: <b>{{ aufgabe.ersteller.name }}</b>
        </div>
      }
      @if (aufgabe.mitUenbTeilen && authenticationService.isVnb(uflaUser); ) {
        <div class="mit-uenb-teilen"
             data-qa="geteilt-mit-amprion">
          Geteilt mit: <b>Amprion</b>
        </div>
      }
      @if (zuweisungenNameIfLengthEq1) {
        <div class="info">
          <mat-icon svgIcon="innogy_picto_person"></mat-icon>
          <span>{{ zuweisungenNameIfLengthEq1 }}</span>
        </div>
      }
    </mat-card-actions>
    <mat-card-title>
      <h3 data-qa="title">{{ aufgabe.name }}</h3>
    </mat-card-title>
    <mat-card-content>
      <div data-qa="kurzbeschreibung">{{ kurzbeschreibungShortened }}</div>
    </mat-card-content>

  </div>
  <div class="progress">
    <mat-card-actions>
      <div class="info">
        <mat-icon>playlist_add_check</mat-icon>
        {{ anzahlZuweisungenBestaetigt }} / {{ anzahlZuweisungen }}
      </div>
      <div class="info">
        <mat-icon> {{ aufgabe.type | aufgabeTypeImage }}</mat-icon>
        {{ aufgabe.type | aufgabeTypeFristPrefix }}:&nbsp;{{ aufgabe.frist | date: 'dd.MM.yyyy' }}
      </div>
      @if (aufgabe.emailBenachrichtigungSenden) {
        <div class="info" data-qa="emailBenachrichtigungSenden">
          <mat-icon>mail_outline</mat-icon>
          <span>E-Mail Benachrichtigung</span>
        </div>
      }
      @if (aufgabe.erinnerungsMail) {
        <div class="info" data-qa="erinnerungsMailSenden">
          <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
          <span>Erinnerung</span>
        </div>
      }
      @if (aufgabe.hatDokument) {
        <div data-qa="aufgabeCardHatDokument"
             class="info"
        >
          <mat-icon>attach_file</mat-icon>
          Anhang
        </div>
      }
      @if (aufgabe.emailBenachrichtigungNachVorgangabschluss) {
        <div class="info" data-qa="emailBenachrichtigungNachVorgangabschluss">
          <mat-icon>mail</mat-icon>
          <span>Benachrichtigung nach Abschluss</span>
        </div>
      }
    </mat-card-actions>
    <div class="indicator-container">
      <div
        [style.width]="prozentErledigtBar  + '%'"
        [attr.data-qa]="'prozent-erledigt-' + prozentErledigtBar"
        class="indicator indicator-{{colorProzentErledigt}}"
      >&nbsp;
      </div>
    </div>
  </div>
</mat-card>
